import axios from 'axios';
import qs from 'query-string';

/**
 * Проверяет достпуна ли квартира для подключения
 * @param {object} request Объект запроса
 * @param {string} request.city
 * @param {number} request.cityId
 * @param {string} request.street
 * @param {number} request.streetId
 * @param {string} request.house
 * @param {number} request.houseId
 * @param {boolean} request.isConnected
 * @param {string} request.flat
 */
function checkConnection(request) {
  const requestData = qs.stringify(request);

  return axios.post('/customers/products/home/request/checkconnection/', requestData,
    { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
}

/**
 * Возможные состояния кваритиры
 * @typedef FlatConnectionStates
 * @type {object}
 * @property {number} none - не проверена или не удалось проверить
 * @property {number} success - квартира доступно для подключения
 * @property {number} alreadyInUse = квартира уже подключена к билайн
 */
export const flatConnectionStates = {
  none: 0,
  success: 1,
  alreadyInUse: 2,
  partnerConnected: 3,
  error: 4,
};

/**
 * Преобразует объект `connectionData` к обекту необходимому для передачи в метод `checkConnection`
 */
export const convertConnectionDataToCheckConnectionData = (connectionData) => {
  const { city, street, house, flat } = connectionData;
  return {
    city: city.label,
    cityId: city.id,
    streetId: street.id,
    street: street.label,
    house: house.label,
    houseId: house.id,
    isConnected: house.isConnected,
    flat,
  };
};

/**
 * Проверяет доступность квартиры для подключения
 * @param {object} connectionData Объект содержащий проверяемый адрес
 * @param {{ id: number, label: string }} connectionData.city Объект города с полями `id` и `label`
 * @param {{ id: number, label: string }} connectionData.street Объект улицы с полями `id` и `label`
 * @param {{ id: number, label: string, isConnected: boolean }} connectionData.house Объект
 * дома с полями `id`, `label` и `isConnected`
 * @param {string} connectionData.flat Строка содежащая номер квартиры
 * @returns {Promise<{
 *  connectionState: FlatConnectionStates,
 *  hasRequestOnAddress: boolean,
 *  callCenterWorkStartTime: string,
 *  callCenterWorkEndTime: string,
 * }>} Возвращает промис который принимает объект с информацией о доступности квартиры
 */
export const checkFlatConnection = (connectionData) => {
  const requestData = convertConnectionDataToCheckConnectionData(connectionData);

  return checkConnection(requestData).then(({ data }) => ({
    connectionState: data.View.ConnectionState,
    hasRequestOnAddress: data.View.HasRequestOnAddress,
    callCenterWorkStartTime: data.View.CallCenterWorkStartTime,
    callCenterWorkEndTime: data.View.CallCenterWorkEndTime,
  }));
};

/**
 * Вызывает секцию смены города из шапки сайта
 */
export const changeCity = () => {
  const regionsButton = document.querySelector('#toggleButton-regions-desktop');
  if (regionsButton) regionsButton.click();
};
